import { render } from "./BarProgress2.vue?vue&type=template&id=a3d82ffc"
import script from "./BarProgress2.vue?vue&type=script&lang=js"
export * from "./BarProgress2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BarProgress2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3d82ffc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3d82ffc', __exports__)) {
    api.reload('a3d82ffc', __exports__)
  }
  
  module.hot.accept("./BarProgress2.vue?vue&type=template&id=a3d82ffc", () => {
    api.rerender('a3d82ffc', render)
  })

}


export default __exports__